<ngx-bootstrap-spinner
  loaderTemplate="<img src='/assets/images/fireball.gif' />">
</ngx-bootstrap-spinner>

<router-outlet>

</router-outlet>
